const swiper = new Swiper(".swiper", {
    slidesPerView: 2.35, // スライド数
    spaceBetween: "1%", // スライド間の余白
    freeMode: true,    
    scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
    },
    breakpoints: {
        //750px以上の場合
        750: {
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            slidesPerView: 2.5,
        }
    }
});
